const ACCOUNT_SWITCHER = {
    SWITCH_ACCOUNT_BUTTON_CLICKED: {
        event: 'switch_account_button_clicked',
        eventProperties: {
            description:
                'Triggered when a Parent Partner Admin (PPA) clicks the Switch Account button to open the Account Switcher modal',
        },
    },
    SWITCH_ACCOUNT_MODAL_CONFIRMED: {
        event: 'switch_account_modal_confirmed',
        eventProperties: {
            description:
                'Triggered when a PPA confirms a partner account selection in the modal and the view changes to that partner context',
        },
    },
    VIEW_MODE_CHANGED: {
        event: 'view_mode_changed',
        eventProperties: {
            description:
                'Fired when a PPA switches between primary and non-primary account views. Used to determine when a session is in switched mode',
        },
    },
    VIEWING_ACCOUNT_BANNER_VISIBLE: {
        event: 'viewing_account_banner_visible',
        eventProperties: {
            description:
                'Fires when the Currently Viewing Account banner is rendered on screen. Confirms correct visibility while in non-primary mode',
        },
    },
    MCA_SWITCH_ACCOUNT_BUTTON_CLICKED: {
        event: 'mca_switch_account_button_clicked',
        eventProperties: {
            description:
                'Triggered when an MCA user clicks the Switch Account button to open the Account Switcher modal',
        },
    },
    MCA_COMPANY_SWITCHED: {
        event: 'mca_company_switched',
        eventProperties: {
            description:
                'Triggered when an MCA user confirms a client company selection in the modal and the view changes to that client context',
        },
    },
    MCA_VIEW_MODE_CHANGED: {
        event: 'mca_view_mode_changed',
        eventProperties: {
            description:
                'Fired when an MCA user switches between primary and non-primary client account views',
        },
    },
};

export default ACCOUNT_SWITCHER;
